import React, { useEffect } from 'react';
import { PartyPopperIcon, ArrowUpIcon } from 'lucide-react';
import { trackUpsellEvent } from '../../utils/upsellCopy';
interface CelebrateNudgeProps {
  isVisible: boolean;
  onClose: () => void;
  onUpgrade: () => void;
  message: string;
}
export function CelebrateNudge({
  isVisible,
  onClose,
  onUpgrade,
  message
}: CelebrateNudgeProps) {
  useEffect(() => {
    if (isVisible) {
      trackUpsellEvent('upsell_impression', {
        surface: 'celebrate_nudge'
      });
      const timer = setTimeout(() => {
        onClose();
      }, 8000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);
  if (!isVisible) return null;
  const handleUpgradeClick = () => {
    trackUpsellEvent('upsell_click', {
      surface: 'celebrate_nudge',
      cta: 'upgrade'
    });
    onUpgrade();
  };
  return <div className="fixed bottom-6 right-6 z-50 animate-in slide-in-from-bottom-5" data-id="element-3498">
      <div className="bg-white rounded-lg shadow-lg border-2 border-green-500 p-4 max-w-sm" data-id="element-3499">
        <div className="flex items-start gap-3" data-id="element-3500">
          <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-3501">
            <PartyPopperIcon className="w-5 h-5 text-green-600" data-id="element-3502" />
          </div>
          <div className="flex-1" data-id="element-3503">
            <p className="text-sm font-semibold text-gray-900 mb-1" data-id="element-3504">
              Great work!
            </p>
            <p className="text-sm text-gray-600 mb-3" data-id="element-3505">{message}</p>
            <button onClick={handleUpgradeClick} className="flex items-center gap-2 text-sm font-medium text-purple-600 hover:text-purple-700" data-id="element-3506">
              <ArrowUpIcon className="w-4 h-4" data-id="element-3507" />
              Unlock more by upgrading
            </button>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-lg leading-none" data-id="element-3508">
            ×
          </button>
        </div>
      </div>
    </div>;
}